let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3hNPM")).then(() => parcelRequire('aRnPK'));